import ConfigService from '@/services/atp-config'
import * as types from '../mutations'

const state = {
  atpConfig: {},
  isLoadingATPConfig: false
}

const getters = {
  getATPConfig: (state) => state.atpConfig,
  isLoadingATPConfig: (state) => state.isLoadingATPConfig
}

const actions = {
  setATPConfig ({ commit }, config) {
    commit(types.SET_ATP_CONFIGURATION, config)
  },

  async loadATPConfig ({ commit }) {
    const config = await ConfigService.getATPConfiguration()
    commit(types.SET_ATP_CONFIGURATION, config)
  },

  setIsLoadingATPConfig ({ commit }, isLoading) {
    commit(types.SET_IS_LOADING_ATP_CONFIG, isLoading)
  },

  async updateATPConfig ({ commit }, payload) {
    const { accountId } = payload
    const results = await ConfigService.updateATPConfiguration(accountId)
    commit(types.SET_ATP_CONFIGURATION, results)
  }
}

const mutations = {
  [types.UPDATE_ATP_CONFIGURATION]  (state, config) {
    state.atpConfig = {
      ...state.atpConfig,
      ...config
    }
  },

  [types.SET_ATP_CONFIGURATION] (state, config) {
    state.atpConfig = config
  },

  [types.SET_IS_LOADING_ATP_CONFIG] (state, isLoading) {
    state.isLoadingATPConfig = isLoading
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
